import { Component } from '@angular/core';

@Component({
  selector: 'app-why-us',
  imports: [],
  templateUrl: './why-us.component.html',
  styleUrl: './why-us.component.css',
})
export class WhyUsComponent {

}
